import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import styled from "styled-components";
import { Button, Container, Typography, TextField } from "@material-ui/core";
import { DropzoneDialog } from "material-ui-dropzone";

import Header from "../components/Header";
import CompanyProfileActions from "../actions/companyProfile.actions";

const StyledTextField = styled(TextField)`
  margin-bottom: 10px;
  background: #efefef !important;
  border-color: black !important;
  * {
    border-color: black !important;
  }
  label {
    color: gray!important
  }
  input {
    color: black !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-text-fill-color: black !important;
  }
`;

const StyledBtn = styled(Button)`
  color: #fff !important;
  border-color: #000 !important;
  background-color: #3f3f3f !important;
  padding-left: 25px;
  padding-right: 25px;
  width: 100px;
  margin: auto;
`;

const StyledAddLogoBtn = styled(Button)`
  background: #3f3f3f !important;
  width: 300px;
  border: 1px solid #3f3f3f;
  margin-bottom: 10px;
  color: white;
`;

const ImagePreview = styled.img`
  width: 100px;
  background: white;
`;

const Profile = (props) => {
  const [openModal, setOpenModal] = useState(false);
  let history = useHistory();

  useEffect(() => {
    props.getCompanyProfile();
  }, []);

  useEffect(() => {
    if (!props.auth.access_token) {
      history.push("/");
    }
  }, [props.auth.access_token]);

  function handleSave(files) {
    props.updateCompanyProfileInfo({
      key: "logo",
      value: files[0],
    });
    setOpenModal(false);
  }

  function triggerSave() {
    if (props.profile._id) {
      props.updateCompanyProfile(() => {
        history.push("/campaigns");
      });
    } else {
      props.createCompanyProfile(() => {
        history.push("/campaigns");
      });
    }
  }

  var imgURL = null;
  if (props.profile.logo && typeof props.profile.logo != "string") {
    imgURL = (window.URL ? URL : window.webkitURL).createObjectURL(
      props.profile.logo
    );
  }
  if (props.profile.logo && typeof props.profile.logo === "string") {
    imgURL = props.profile.logo;
  }
  const profile = props.profile;
  return (
    <Container fixed>
      <Header IsProfileCreated={!!profile._id}>
        <Typography
          component="div"
          align="left"
          style={{ marginTop: "0px", background: "#fff" }}
        >
          {imgURL && (
            <div>
              <ImagePreview src={imgURL} />
            </div>
          )}
          <StyledAddLogoBtn onClick={() => setOpenModal(true)}>
            Add/Update Company Logo
          </StyledAddLogoBtn>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <StyledTextField
              id="brand_name"
              label="Brand Name"
              value={profile.brandName || ""}
              onChange={(ev) => {
                props.updateCompanyProfileInfo({
                  key: "brandName",
                  value: ev.target.value,
                });
              }}
              variant="outlined"
              disabled={!!profile._id}
            />
            <StyledTextField
              id="name"
              label="Company Name"
              value={profile.companyName || ""}
              onChange={(ev) => {
                props.updateCompanyProfileInfo({
                  key: "companyName",
                  value: ev.target.value,
                });
              }}
              variant="outlined"
            />
            <DropzoneDialog
              open={openModal}
              onSave={handleSave}
              acceptedFiles={["image/jpeg", "image/png", "image/bmp"]}
              showPreviews={true}
              maxFileSize={5000000}
              onClose={() => setOpenModal(false)}
              filesLimit={1}
            />
            <StyledTextField
              id="address"
              label="Company Address"
              variant="outlined"
              value={profile.address || ""}
              onChange={(ev) => {
                props.updateCompanyProfileInfo({
                  key: "address",
                  value: ev.target.value,
                });
              }}
              multiline
              rows={4}
            />
            <StyledTextField
              id="contactPersonName"
              label="Contact Person Name"
              value={profile.contactPersonName || ""}
              onChange={(ev) => {
                props.updateCompanyProfileInfo({
                  key: "contactPersonName",
                  value: ev.target.value,
                });
              }}
              variant="outlined"
            />
            <StyledBtn
              variant="outlined"
              color="primary"
              onClick={() => triggerSave()}
            >
              Save
            </StyledBtn>
          </div>
        </Typography>
      </Header>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.companyProfile.profile,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCompanyProfile: () =>
      dispatch(CompanyProfileActions.getCompanyProfile()),
    updateCompanyProfileInfo: (payload) =>
      dispatch(CompanyProfileActions.updateCompanyProfileInfo(payload)),
    createCompanyProfile: (cb) =>
      dispatch(CompanyProfileActions.createCompanyProfile(cb)),
    updateCompanyProfile: (cb) =>
      dispatch(CompanyProfileActions.updateCompanyProfile(cb)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
